import React from "react";
import { Linkedin, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0B0B0B] border-t border-white/5 pt-24 pb-32 md:pb-16" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-6">
            <div className="font-cinzel text-[10px] tracking-[0.4em] text-[#C8A45D] mb-3">NEXUS LEGAL</div>
            <div className="font-serif-display text-3xl md:text-5xl text-white/95 leading-[1.05] mb-6">Harshavardhan<br/>Prakash Patil</div>
            <div className="text-white/50 font-body text-sm">Advocate · Bombay High Court · Kolhapur Bench</div>
          </div>
          <div className="md:col-span-3">
            <div className="font-cinzel text-[10px] tracking-[0.3em] text-white/40 mb-4">Mumbai</div>
            <div className="text-white/70 text-sm space-y-1 font-body">
              <div>Office 303, Rajendra Chambers</div>
              <div>19 Nanabhai Lane, Fort</div>
              <div>Mumbai – 400001</div>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="font-cinzel text-[10px] tracking-[0.3em] text-white/40 mb-4">Kolhapur</div>
            <div className="text-white/70 text-sm space-y-1 font-body">
              <div>Arunodaya Apartment, 1st Floor</div>
              <div>Azad Chowk, Kolhapur – 416001</div>
              <div>+91 76667 53201</div>
            </div>
          </div>
        </div>

        <div className="hairline mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="text-white/40 font-body text-xs">© {new Date().getFullYear()} Nexus Legal · All rights reserved.</div>
          <div className="flex gap-6">
            {[
              { Icon: Linkedin, href: "https://www.linkedin.com/in/harshavardhan-patil-330b79162?utm_source=share_via&utm_content=profile&utm_medium=member_android", label: "linkedin" },
              { Icon: Instagram, href: "https://www.instagram.com/adv.harshavardhanprakashpatil/", label: "instagram" },
              { Icon: Youtube, href: "https://www.youtube.com/@Adv.HarshavardhanPatil", label: "youtube" },
            ].map(({Icon, href, label}) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" className="text-white/50 hover:text-[#C8A45D] transition-colors" data-testid={`social-${label}`}><Icon size={18} strokeWidth={1.2}/></a>
            ))}
          </div>
          <div className="text-white/30 font-cinzel text-[10px] tracking-[0.3em]">CRAFTED WITH RESTRAINT</div>
        </div>
      </div>
    </footer>
  );
}
